var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/facet-option.j2"] = require( "macros/facet-option.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-size-group-facet.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/facet-option.j2", false, "category/templates/facets/category-size-group-facet.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("facetOption")) {
var t_4 = t_1.facetOption;
} else {
cb(new Error("cannot import 'facetOption'")); return;
}
context.setVariable("facetOption", t_4);
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"refinements");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("refinement", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "<div class=\"c-facet-group__outer\">\n\n        <h3 class=\"c-facet-group__heading\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"sizeClassName"), env.opts.autoescape);
output += "</h3>\n        <ul data-facet-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"name"), env.opts.autoescape);
output += "\" class=\"o-row c-facet__ul c-facet__ul--";
output += runtime.suppressValue(env.getFilter("lower").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"displayName")), env.opts.autoescape);
output += "\" data-qa-facet-name=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "navItem")),"name"), env.opts.autoescape);
output += "\">";
frame = frame.push();
var t_11 = runtime.memberLookup((t_8),"groupRefinements");
if(t_11) {var t_10 = t_11.length;
for(var t_9=0; t_9 < t_11.length; t_9++) {
var t_12 = t_11[t_9];
frame.set("facet", t_12);
frame.set("loop.index", t_9 + 1);
frame.set("loop.index0", t_9);
frame.set("loop.revindex", t_10 - t_9);
frame.set("loop.revindex0", t_10 - t_9 - 1);
frame.set("loop.first", t_9 === 0);
frame.set("loop.last", t_9 === t_10 - 1);
frame.set("loop.length", t_10);
var t_13;
t_13 = runtime.memberLookup((t_12),"name");
frame.set("facetName", t_13, true);
if(frame.topLevel) {
context.setVariable("facetName", t_13);
}
if(frame.topLevel) {
context.addExport("facetName", t_13);
}
var t_14;
t_14 = env.getFilter("lower").call(context, env.getFilter("sanitize_attr").call(context, runtime.memberLookup((t_12),"value")));
frame.set("facetValue", t_14, true);
if(frame.topLevel) {
context.setVariable("facetValue", t_14);
}
if(frame.topLevel) {
context.addExport("facetValue", t_14);
}
var t_15;
t_15 = (runtime.contextOrFrameLookup(context, frame, "showResultsCount")?runtime.memberLookup((t_12),"count"):0);
frame.set("refinementsCount", t_15, true);
if(frame.topLevel) {
context.setVariable("refinementsCount", t_15);
}
if(frame.topLevel) {
context.addExport("refinementsCount", t_15);
}
output += runtime.suppressValue((lineno = 16, colno = 28, runtime.callWrap(t_4, "facetOption", context, [runtime.contextOrFrameLookup(context, frame, "category"),t_12,runtime.memberLookup((t_12),"value"),runtime.contextOrFrameLookup(context, frame, "facetName"),runtime.contextOrFrameLookup(context, frame, "facetValue"),runtime.makeKeywordArgs({"gaAttributes": (lineno = 17, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, [(lineno = 17, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.pageType",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"pageTypeKey")])),"filter by " + "" + runtime.contextOrFrameLookup(context, frame, "facetName"),runtime.contextOrFrameLookup(context, frame, "facetValue"),{"no_of_results": runtime.memberLookup((t_12),"count")}])),"listItemDataAttributes": "data-facet-value=\"" + "" + env.getFilter("escape_html_attributes").call(context, runtime.contextOrFrameLookup(context, frame, "facetValue")) + "" + "\"","refinementsCount": runtime.contextOrFrameLookup(context, frame, "refinementsCount")})])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</ul>\n\n    </div>";
;
}
}
frame = frame.pop();
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-size-group-facet.j2"] , dependencies)